import { Action } from 'api/types';

const host = String(process.env.REACT_APP_API_URL);

export const requestHostInterceptor = () => async (action: Action) => {
  if (action.endpoint.startsWith('http')) {
    return action;
  }

  return {
    ...action,
    endpoint: `${host}${action.endpoint}`,
  };
};
